import React from "react";
import { LuImage, LuPackage } from "react-icons/lu";

import cx from "../ui/cx";

type Props = {
  name: string;
  imageUrl?: string | null;
  className?: string;
  // A thumbnail too small for the "no photo" text shows only an icon.
  compact?: boolean;
};

// The material's photo, or a gray tile saying it has none.
const MaterialPhoto = ({ name, imageUrl, className, compact }: Props) =>
  imageUrl ? (
    <img
      src={imageUrl}
      alt={name}
      loading="lazy"
      className={cx("bg-gray-100 object-cover", className)}
    />
  ) : compact ? (
    <div
      className={cx("flex items-center justify-center bg-gray-100", className)}
    >
      <LuPackage className="h-5 w-5 text-gray-400" />
    </div>
  ) : (
    <div
      className={cx(
        "flex flex-col items-center justify-center bg-gray-100 text-gray-400",
        className
      )}
    >
      <LuImage className="h-7 w-7" />
      <span className="mt-1 text-xs">કોઈ ફોટો નથી</span>
    </div>
  );

export default MaterialPhoto;
